<template>
    <div
        class="col-span-full md:col-start-2 md:col-span-10 lg:col-start-3 lg:col-span-8"
    >
        <div
            class="relative aspect-video max-h-[100dvh] w-full overflow-hidden"
            :class="{'!fixed inset-0': content?.sticky}"
        >
            <ResponsiveImage v-if="content?.image" :image-id="content.image" class="absolute inset-0 h-full w-full object-cover"/>
        </div>
        <div v-if="retrieve_content_by_label('text')">
            <h1 class="text-caption text-dark-blue/75 col-span-full ">{{ retrieve_content_by_label('text') }}</h1>
        </div>

    </div>
</template>

<script lang="ts" setup>
import SetImg from "~/components/view/SetImg.vue"

const mainStore = useMainStore()
const { get_value: getLocalizedValue } = useLocalizedValue()

const {content, properties} = defineProps({
    content: {
        type: Object as PropType<{image: string, priority?: boolean}>,
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    }
})

const retrieve_content_by_label = (label: string): string | null => {
    if (!content || !content[label]) return null
    return getLocalizedValue(content[label])
}
</script>

<!--<style scoped lang="scss">-->
<!--</style>-->
